import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import pep from '@/store/pep'
import Cookies from 'js-cookie'
import router from '@/router'
import mixins from '@/mixins'

import { initSessionInterval, deleteInterval } from '@/session/session'

Vue.use(Vuex)

function getCurrentTime () {
  let currentDay = new Date()
  return (currentDay)
}

export default new Vuex.Store({
  modules: {
    pep
  },
  state: {
    investmentStatus: false,
    creditsToCompare: [],
    simulatedValues: {},
    creditCompareAmountSelect: 0,
    comesFromComparison: false,
    userHasNotClabeStp: true,
    userBalance: 0,
    userClabe: null,
    user_rfc: null,
    token: sessionStorage.getItem('sofom_access_token') || null,
    tokenTime: sessionStorage.getItem('sofom_token_time') || null,
    session: sessionStorage.getItem('sofom_session_time') || null,
    alive: JSON.parse(sessionStorage.getItem('sofom_session_alive')) || false,
    email: sessionStorage.getItem('sofom_email') || null,
    currentStep: JSON.parse(sessionStorage.getItem('sofom_current_step')) || 0,
    userName: sessionStorage.getItem('sofom_user_name') || null,
    isInvestor: JSON.parse(sessionStorage.getItem('sofom_is_investor')) || false,
    lastLogin: sessionStorage.getItem('sofom_last_login') || null
  },
  getters: {
    sessionIsAlive (state) {
      return state.alive
    },
    getToken (state) {
      return state.token
    },
    getTokenTime (state) {
      return state.tokenTime
    },
    getLastLogin (state) {
      return state.lastLogin
    },
    getFullUserName (state) {
      return state.userName
    },
    getIsInvestor (state) {
      return state.isInvestor
    },
    getCurrentStep (state) {
      return state.currentStep
    },
    getEmail (state) {
      return state.email
    },
    getSessionInitialTime (state) {
      return state.session
    },
    getUserBalance (state) {
      return state.userBalance
    },
    creditsToCompare (state) {
      return state.creditsToCompare
    },
    getCreditCompareAmountSelect (state) {
      return state.creditCompareAmountSelect
    },
    getComesFromComparison (state) {
      return state.comesFromComparison
    },
    getSimulatedValues (state) {
      return state.simulatedValues
    },
    getUserClabe (state) {
      return state.userClabe
    },
    getUserRFC (state) {
      return state.user_rfc
    }
  },
  mutations: {
    compareCredits (state, id) {
      if (!state.creditsToCompare.includes(id)) {
        state.creditsToCompare.push(id)
      } else {
        state.creditsToCompare.splice(state.creditsToCompare.indexOf(id), 1)
      }
    },
    setCreditCompareAmountSelect (state, creditCompareAmountSelect) {
      state.creditCompareAmountSelect = creditCompareAmountSelect
    },
    setComesFromComparison (state, comesFromComparison) {
      state.comesFromComparison = comesFromComparison
    },
    setSimulatedValues (state, simulatedValues) {
      state.simulatedValues = simulatedValues
    },
    saveToken (state, token) {
      state.token = token
    },
    setTokenTime (state, tokenTime) {
      state.tokenTime = tokenTime
    },
    saveEmail (state, email) {
      state.email = email
    },
    SET_CURRENT_STEP (state, currentStep) {
      state.currentStep = currentStep
    },
    saveUserName (state, userName) {
      state.userName = userName
    },
    saveIsInvestor (state, isInvestor) {
      state.isInvestor = isInvestor
    },
    saveLastLogin (state, lastLogin) {
      state.lastLogin = lastLogin
    },
    sessionAlive (state, alive) {
      state.alive = alive
    },
    sessionTime (state, sessionTime) {
      state.session = sessionTime
    },
    saveUserBalance (state, balance) {
      state.userBalance = balance
    },
    sessionDestroy (state) {
      state.alive = false
      state.session = null
      state.token = null
      state.tokenTime = null
      state.userName = null
      state.userPhone = null
      state.lastLogin = null
      state.isInvestor = false
      state.email = null
    },
    setUserClabe (state, userClabe) {
      state.userClabe = userClabe
    },
    SET_USER_RFC (state, rfc) {
      state.user_rfc = rfc
    }
  },
  actions: {
    login ({ dispatch, commit }, credentials) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/auth/login/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'email': credentials.email,
          'password': credentials.password
        }
      }

      return axios({
        method: options.method,
        url: options.url,
        headers: options.headers,
        data: options.data
      })
        .then(async response => {
          if (response.status === 200) {
            const token = response.data.token
            let currentDay = new Date()
            const sessionTime = (currentDay.getHours() + ':' +
              currentDay.getMinutes() + ':' + currentDay.getSeconds() +
              ':' + currentDay.getMilliseconds())
            sessionStorage.setItem('sofom_session_alive', true)
            commit('sessionAlive', true)
            sessionStorage.setItem('sofom_access_token', token)
            commit('saveToken', token)
            sessionStorage.setItem('sofom_token_time', getCurrentTime())
            commit('setTokenTime', getCurrentTime())
            sessionStorage.setItem('sofom_session_time', sessionTime)
            commit('sessionTime', sessionTime)
            sessionStorage.setItem('sofom_email', credentials.email)
            commit('saveEmail', credentials.email)
            await dispatch('checkCurrentStep')
            initSessionInterval()
          }
          return Promise.resolve(response)
        })
        .catch((error) => {
          return Promise.reject(error.response)
        })
    },
    async middlewareLogin ({dispatch, commit}, token) {
      let currentDay = new Date()
      const sessionTime = (currentDay.getHours() + ':' +
        currentDay.getMinutes() + ':' + currentDay.getSeconds() +
        ':' + currentDay.getMilliseconds())
      sessionStorage.setItem('sofom_session_alive', true)
      commit('sessionAlive', true)
      sessionStorage.setItem('sofom_access_token', token)
      commit('saveToken', token)
      sessionStorage.setItem('sofom_token_time', getCurrentTime())
      commit('setTokenTime', getCurrentTime())
      sessionStorage.setItem('sofom_session_time', sessionTime)
      commit('sessionTime', sessionTime)
      await dispatch('checkCurrentStep')
      initSessionInterval()
    },
    signout ({ commit, getters }) {
      deleteInterval()
      Cookies.remove('sofom_tkn', {path: '/', domain: '.cumplo.mx'})
      Cookies.remove('sofom_tkn_exp', {path: '/', domain: '.cumplo.mx'})
      Cookies.remove('sofom_email', {path: '/', domain: '.cumplo.mx'})
      let options = {
        method: 'DELETE',
        url: process.env.AUTH_BASE + '/auth/signout/',
        headers: {
          'Authorization': `Token ${getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      commit('sessionDestroy')
      sessionStorage.clear()

      return axios({
        method: options.method,
        url: options.url,
        headers: options.headers,
        data: options.data
      })
        .then(response => {
          if (router.currentRoute.name !== 'Home') {
            router.replace({ name: 'Home' })
          }
          return Promise.resolve(response)
        })
        .catch((error) => {
          if (router.currentRoute.name !== 'Home') {
            router.replace({ name: 'Home' })
          }
          return Promise.reject(error.response)
        })
    },
    middlewareGetEmail ({ commit }, email) {
      sessionStorage.setItem('sofom_email', email)
      commit('saveEmail', email)
    },
    checkCurrentStep ({ commit, getters }) {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/steps/',
        headers: {
          'Authorization': `Token ${getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      return axios({
        method: options.method,
        url: options.url,
        headers: options.headers
      })
        .then(response => {
          if (response.status === 200) {
            sessionStorage.setItem('sofom_current_step', response.data.step)
            commit('SET_CURRENT_STEP', response.data.step)
            sessionStorage.setItem('sofom_user_name', response.data.name)
            commit('saveUserName', response.data.name)
            sessionStorage.setItem('sofom_is_investor', response.data.is_investor)
            commit('saveIsInvestor', response.data.is_investor)
            sessionStorage.setItem('sofom_last_login', response.data.last_login)
            commit('saveLastLogin', response.data.last_login)
          }
          Promise.resolve(response)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            mixins.modalError(error.response.data, error.response.status)
          } else {
            mixins.modalError(
              {error: ['Se ha producido un error interno,' +
                'por favor intenta nuevamente']}, error.response.status)
          }
          Promise.reject(error.response)
        })
    },
    refreshToken ({ commit, getters }) {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/auth/refresh-token/',
        headers: {
          'Authorization': `Token ${getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      return new Promise((resolve, reject) => {
        axios(
          {
            method: options.method,
            url: options.url,
            headers: options.headers
          })
          .then(response => {
            if (response.status === 200) {
              sessionStorage.setItem('sofom_access_token', response.data.token)
              commit('saveToken', response.data.token)
              sessionStorage.setItem('sofom_token_time', getCurrentTime())
              commit('setTokenTime', getCurrentTime())
              const tokenExpiracyDate = Date.now() + 300000
              Cookies.set('sofom_tkn', response.data.token, {
                path: '/', domain: '.cumplo.mx'})
              Cookies.set('sofom_tkn_exp', tokenExpiracyDate, {
                path: '/', domain: '.cumplo.mx'})
              resolve(response)
            }
          })
          .catch((error) => {
            if (error.response.status !== 401) {
              mixins.modalError(
                {error: ['Se ha producido un error interno,' +
                  'por favor intenta nuevamente']}, error.response.status)
            }
            reject(error.response)
          })
      })
    },
    setCurrentStep (context, currentStep) {
      sessionStorage.setItem('sofom_current_step', currentStep)
      context.commit('SET_CURRENT_STEP', currentStep)
      initSessionInterval()
    },
    finishedProfile ({ commit }) {
      sessionStorage.setItem('sofom_current_step', -1)
      sessionStorage.setItem('sofom_is_investor', true)
      commit('SET_CURRENT_STEP', -1)
      commit('saveIsInvestor', true)
    },
    storeUserBalance (context, balance) {
      context.commit('saveUserBalance', balance)
    },
    addToCompareCredits ({ commit }, id) {
      commit('compareCredits', id)
    },
    creditCompareAmountSelect (context, amountSimulated) {
      context.commit('setCreditCompareAmountSelect', amountSimulated)
    },
    comesFromComparison (context, assertion) {
      context.commit('setComesFromComparison', assertion)
    },
    simulatedValues (context, simulatedValues) {
      context.commit('setSimulatedValues', simulatedValues)
    },
    storeUserClabe (context, clabe) {
      context.commit('setUserClabe', clabe)
    },
    setUserRfc (context, rfc) {
      context.commit('SET_USER_RFC', rfc)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js